export enum EReconParticipantsColumnKeys {
  GUID = 'guid',
  DebtorGUID = 'debtor_guid',
  IsBlocked = 'is_blocked',
  Name = 'name',
  Saldo = 'saldo',
  TotalIn = 'total_in',
  TotalOut = 'total_out',
  Status = 'status',
}

export enum EQueryParams {
  Status = 'status',
  Counterparty = 'counterparty',
  Record = 'record',
}

export enum EReconColumnKeys {
  CreatedAt = 'created_at',
  Calculations = 'calculations',
  Saldo = 'saldo',
  TotalIn = 'total_in',
  TotalOut = 'total_out',
  EndDate = 'end_date',
};
